/* eslint-disable */
import React, { useEffect, useState } from "react";
import { Modal, Button } from 'react-bootstrap';
import { useDispatch, shallowEqual, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import "../../styles/admin_user_nav.css"
import { addUser, getAllApprovalUser, getSupervisorByDeptAndRoleId } from "../actions/userAction";
// import { getAllDistrictsList } from "../../venuemanagement/actions/venueManagementAction";
import { getDepartments } from "../../../common/actions/commonActions";
import userLabels from '../labels/users_en.json';
import _ from "lodash/fp";
import { emailRegex } from "../../../common/constants/regex";


const AddUser = (props) => {
    const { register, handleSubmit, formState, errors, watch } = useForm({
        mode: "onChange"
    });
    const dispatch = useDispatch();
    const { adminDepartments } = useSelector((state) => state.common,
        shallowEqual
    );
    const { roleByDept, supervisorByRole } = useSelector((state) => state.userManagementReducer,
        shallowEqual
    );
    // const { allDistrictsList } = useSelector((state) => state.venueManagementReducer,
    //     shallowEqual
    // );

    useEffect(() => {
        dispatch(getDepartments());
        // eslint-disable-next-line
    }, [])

    const [departmentList, setDeparmentList] = useState("")
    const [roleList, setRoleList] = useState("")
    const [supervisorList, setSupervisorList] = useState("")
    const [districtList, setDistrictList] = useState("")

    const handleChangeDepartment = (e) => {
        setDeparmentList(e.target.value)
        getSupervisor()
    }
    const handleChangeRole = (e) => {
        setRoleList(e.target.value)
        getSupervisor()
        if (e.target.value === "7") {
            // dispatch(getAllDistrictsList(27))
        }
    }
    const handleChangeSupervisor = (e) => {
        setSupervisorList(e.target.value)
    }

    const getSupervisor = () => {
        let deptId = watch("department");
        dispatch(getSupervisorByDeptAndRoleId(deptId))
    }

    const cancelModal = () => {
        props.setShowModal(false)
        setDeparmentList("")
        setDistrictList("")
        setRoleList("")
        setSupervisorList("")
    }
    const onSubmit = (data) => {
        let requestBody = {};
        requestBody.userOasApproval = {
            "approvalType": "New User",
            "email": data.email.toLowerCase().trim(),
            "mobile": data.mobile,
            "password": "Vast@123",
            "isSuperAdmin": 1,
            "isActive": 1,
            "firstName": data.firstName,
            "lastName": data.lastName,
            "districtcode": data.districtcode,
        }
        requestBody.userOasApprovalDeptRoleDto = [
            {
                "isActive": 1,
                "supervisor": {
                    "id": data.userOas
                },
                "role": {
                    "id": data.role
                },
                "department": {
                    "id": data.department
                }
            }
        ]
        const newUser = {
            "username": "",
            "email": data.email,
            "mobile": data.mobile,
            "password": "Sagar@1998",
            "isActive": "true",
            "firstName": data.firstName,
            "lastName": data.lastName,
            "isMobileVerified": "",
            "isEmailVerified": "",
            "isTempPassword": "",
            "createdBy": "",
            "updatedBy": "",
            "isSuperAdmin": "",
            "departmentId": data.department,
            "departmentName": "IT",
            "roleId": data.userOas,
            "roleName": "Admin",
            "supervisorId": "",
            "supervisorName": "",
        }
        props.setShowModal(false)
        dispatch(addUser(newUser))
        setDeparmentList("")
        setDistrictList("")
        setRoleList("")
        setSupervisorList("")
        dispatch(getAllApprovalUser(0,10))
    }

    // const handleAssignAnother = () => {
    //     let list = [...assignAnother]
    //     list.push(
    //         {
    //             department:"",
    //             role:"",
    //             userOas:""
    //         }
    //     )
    //     setAssignAnother(list)
    // }

    // const deleteItem  = (index) => {
    //     let list = [...assignAnother]
    //     list.splice(index, 1)
    //     setAssignAnother(list)
    // }
    const handleDistrictChange = (e) => {
        setDistrictList(e.target.value);
    }
    return (
        <form>
            <Modal size="lg" show={props.showModal}
                onHide={() => {
                    props.setShowModal(false)
                    setDeparmentList("")
                    setDistrictList("")
                    setRoleList("")
                    setSupervisorList("")
                }} backdrop='static'>
                <Modal.Header  className="logout_heading">
                    <Modal.Title  className="logout_title">
                        {props.header}
                    </Modal.Title>
                       <button
                        type="button"
                        className="ms-auto logout_close"
                        aria-label="Close"
                        onClick={cancelModal}
                    >X</button>
                </Modal.Header>
                <Modal.Body>

                    <div className="row" >
                        <div className="form-group col-md-6 mb-0">
                            <label className="LeftText">{userLabels.FIRST_NAME} <span className="redColor">*</span></label>
                            <input
                                type="text"
                                className="form-control"
                                name="firstName"
                                ref={register({
                                    required: true, pattern: {
                                      value: /^[A-Za-z_. ]+$/i
                                    }, maxLength: 30
                                })}
                            />
                            {_.get("firstName.type", errors) === "required" && (
                                <p className="errorText">{userLabels.MANDATORY_FIELD_MESSAGE}</p>
                            )}
                            {_.get("firstName.type", errors) === "pattern" && (
                                <p className="errorText">{userLabels.ENTER_VALID_FIRSTNAME}</p>
                            )}
                            {_.get("firstName.type", errors) === "maxLength" && (
                                <p className="errorText">{userLabels.MAX_VALUE_FOR_30_CHAR}</p>
                            )}

                        </div>
                        <div className="form-group col-md-6 mb-0">
                            <label className="LeftText">{userLabels.LAST_NAME}<span className="redColor">*</span></label>
                            <input
                                type="text"
                                className="form-control"
                                name="lastName"
                                ref={register({
                                    required: true, pattern: {
                                      value: /^[A-Za-z_. ]+$/i
                                    }, maxLength: 30
                                })}
                            />
                            {_.get("lastName.type", errors) === "required" && (
                                <p className="errorText">{userLabels.MANDATORY_FIELD_MESSAGE}</p>
                            )}
                            {_.get("lastName.type", errors) === "pattern" && (
                                <p className="errorText">{userLabels.ENTER_VALID_LASTNAME}</p>
                            )}
                            {_.get("lastName.type", errors) === "maxLength" && (
                                <p className="errorText">{userLabels.MAX_VALUE_FOR_30_CHAR}</p>
                            )}
                        </div>
                        <div className="form-group col-md-6 mb-0">
                            <label className="LeftText">{userLabels.EMAIL_ID}<span className="redColor">*</span></label>
                            <input
                                type="text"
                                className="form-control"
                                name="email"
                                ref={register({ required: true, pattern: emailRegex })}
                            />
                            {_.get("email.type", errors) === "required" && (
                                <p className="errorText">{userLabels.MANDATORY_FIELD_MESSAGE}</p>
                            )}
                            {_.get("email.type", errors) === "pattern" && (
                                <p className="errorText">{userLabels.ENTER_VALID_EMAIL}</p>
                            )}
                        </div>
                        <div className="form-group col-md-6 mb-0">
                            <label className="LeftText">{userLabels.MOBILE_NUMBER}<span className="redColor">*</span></label>
                            <input
                                type="text"
                                className="form-control"
                                name="mobile"
                                maxLength={10}
                                ref={register({
                                    required: true,
                                    pattern: {
                                        value: /^\s*([1-9]{1}[0-9]{9})\s*$/
                                    }
                                })}
                            />
                            {_.get("mobile.type", errors) === "required" && (
                                <p className="errorText">{userLabels.MOBILE_REQ}</p>
                            )}
                            {_.get("mobile.type", errors) === "pattern" && (
                                <p className="errorText">{userLabels.MOBILE_PATTERN}</p>
                            )}
                        </div>


                    </div>
                    <div style={{ height: "200px", overflowY: "auto", overflowX: "hidden" }}>
                        <div className="row" >
                            {/* <div className="form-group col-md-11 mb-0"> */}
                            <div className="form-group col-md-4 mb-0">
                                <label className="LeftText">{userLabels.DEPARTMENT}<span className="redColor">*</span>
                                </label>
                                <select className="form-control" name="department" value={departmentList} onInput={handleChangeDepartment} ref={register({ required: true })}>
                                    <option key="" value="">Select</option>
                                    {adminDepartments && adminDepartments.map((ele, i) => {
                                        return <option key={i} value={ele.id}>{ele.name}</option>
                                    })}
                                </select>
                            </div>
                            <div className="form-group col-md-4 mb-0">
                                <label className="LeftText">{userLabels.ROLE}<span className="redColor">*</span>
                                </label>
                                <select className="form-control" name="role" value={roleList} disabled={!departmentList} onInput={handleChangeRole}>
                                    <option key="" value="">Select</option>
                                    {roleByDept && roleByDept.map((ele, iindex) => {
                                        return <option key={iindex} value={ele.id}>{ele.name}</option>
                                    })}
                                </select>
                            </div>
                            {/* { roleList && roleList === "7" &&
                                 <div className="form-group col-md-3 mb-0">
                                 <label className="LeftText">{userLabels.DISTRICT}<span className="redColor">*</span>
                                 </label>
                                 <select className="form-control" name="districtcode" disabled={!(departmentList && roleList)} value={districtList} onInput={handleDistrictChange} ref={register({ required: true })}>
                                     <option key="" value="">Select</option>
                                     {allDistrictsList &&allDistrictsList.districtList && allDistrictsList.districtList.map((ele, iindex) => {
                                         return <option key={iindex} value={ele.districtcode}>{ele.districtname}</option>
                                     })}
                                 </select>
                             </div>
                            } */}
                            {roleList && roleList !== "7" &&
                                <div className="form-group col-md-3 mb-0">
                                    <label className="LeftText">{userLabels.SUPERVISOR}<span className="redColor"></span>
                                    </label>
                                    <select className="form-control" name="userOas" disabled={!(departmentList && roleList)} value={supervisorList} onInput={handleChangeSupervisor} ref={register()}>
                                        <option key="" value="">Select</option>
                                        {supervisorByRole && supervisorByRole.map((ele, iindex) => {
                                            return <option key={iindex} value={ele.id}>{ele.firstName} {ele.lastName}</option>
                                        })}
                                    </select>
                                </div>}

                            {/* </div> */}
                            {/* <div className="form-group col-md-1 mb-0">
                    <i style={{fontSize:"15px", color:"red", marginTop:"2.5rem"}} className='fa fa-trash' aria-hidden="true" onClick={()=> {deleteItem()}}></i>
                    </div> */}
                        </div>
                    </div>

                    {/* <button type="button" className=" btn btn-primary custom_button  btn-sm" style={{marginTop:"5px"}} onClick={handleAssignAnother}>Assign Another</button> */}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={cancelModal}>{userLabels.CANCEL}</Button>
                    <Button variant="primary" disabled={!formState.isValid} type="submit" onClick={handleSubmit((e) => { onSubmit(e) })}>{userLabels.SAVE}</Button>
                </Modal.Footer>
            </Modal>
        </form>
    )
}



export default AddUser